import {
    createColumnInput,
    createColumnSelect
} from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import lodash from "lodash";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import {
    createFieldInput,
    createFieldTextArea,
    createFieldAttachment,
    createFieldSelect
} from "../../../../../components/input/template-builder/template-builder.logic";
import store from "../../../../../store";

export const callCategory = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "CATEGORY", value: searchQuery })

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.faq.topic"),
            dataIndex: "topic",
            customRender: ({ record }) => <div>{record.topic}</div>,
            align: "center",
        }),
        createColumnInput({
            title: () => i18n.global.t("model.faq.detail"),
            dataIndex: "detail",
            customRender: ({ record }) => <div>{record.detail}</div>,
            align: "center",
            search: { visible: () => false }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.faq.categories"),
            dataIndex: "categories.refCategory.value",
            dataIndexValue: ({ record }) => record.categories.map(d => d.refCategory.value).join(", "),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            inputProp: () => ({ list: callCategory, optLabel: "value", mode: "multiple" }),
            search: { name: "categories.refCategory.id", operator: "in", getValue: ({ value }) => value.map(d => d.id) },
            align: "center",
        }),
    ];
    return columns;
};

export const createFields = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}topic`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => `${i18n.global.t("model.faq.name")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.topic,
                            "onUpdate:value": (value) => (model.topic = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}detail`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => `${i18n.global.t("model.faq.answer")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.detail,
                            "onUpdate:value": (value) => (model.detail = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldAttachment({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}attachments`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => i18n.global.t("model.faq.attachments"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.attachments,
                            listType: "Law",
                            showUploadList: { showPreviewIcon: true, showRemoveIcon: false },
                            multiple: true,
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                    );
                },
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}categories`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => `${i18n.global.t("model.faq.categories")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.categories,
                            "onUpdate:value": (value) => (model.categories = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                            callCategory({ searchQuery }).then(items => items.map(item => ({ refCategory: item }))),
                            optLabel: "refCategory.value",
                            mode: "multiple",
                            optKey: "refCategory.id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refCategory?.value }
            })
        ]
    });
};
